module.exports = "<div class=\"top-bar\">\n  <div class=\"logo\">\n  </div>\n  <div class=\"user-info\">\n    <i class=\"fa fa-fw fa-user-circle\" style=\"font-size: 25px;\"></i>\n    <span class=\"username\" style=\"font-size: 15px;\">Welcome! {{admUserDetails.username}}</span>\n  </div>\n  <div class=\"logout\">\n    <i class=\"fa fa-fw fa-sign-out\" (click)=\"logOut()\" style=\"font-size: 32px;\"></i>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admtopbar/admtopbar.component.html
// module id = ./src/app/admin/admtopbar/admtopbar.component.html
// module chunks = main